import type { FieldValues } from "react-hook-form";
import { FormLineItem } from "../FormLineItem";
import { FormMoney, type FormMoneyProps } from "../fields/FormMoney";
import type { FormLineItemProps } from "../types";

export type FormCurrencyLineItemProps<TFieldValues extends FieldValues> =
	FormLineItemProps<TFieldValues> & Omit<FormMoneyProps<TFieldValues>, "control">;

export const FormCurrencyLineItem = <TFieldValues extends FieldValues>({
	formMethods,
	name,
	defaultValue,
	disabled,
	label,
	id,
	tooltip,
	errorMessage,
	className,
	labelClassName,
	partialRequiresSubmit,
}: FormCurrencyLineItemProps<TFieldValues>) => {
	const { control } = formMethods;
	return (
		<FormLineItem
			formMethods={formMethods}
			id={id}
			name={name}
			label={label}
			tooltip={tooltip}
			className={className}
			labelClassName={labelClassName}
			partialRequiresSubmit={partialRequiresSubmit}
		>
			<FormMoney
				name={name}
				control={control}
				defaultValue={defaultValue}
				disabled={disabled}
				errorMessage={errorMessage}
				compact
				containerClassName="w-full max-w-[220px] bg-surface-base"
			/>
		</FormLineItem>
	);
};
